/** 启动中 / 启动失败 / 404 */
import { CircleAlert, MapPinOff } from "lucide-react";
import { Link } from "react-router";
import { checkStatus, useSession } from "../core/session";
import { Button, EmptyHint, Page, Spinner, StarMascot } from "../ui";

export function Splash() {
  return (
    <div className="kp-center-screen">
      <StarMascot size={72} />
      <Spinner size={22} />
    </div>
  );
}

export function StartError() {
  const error = useSession((s) => s.error);
  return (
    <div className="kp-center-screen">
      <CircleAlert size={40} color="var(--kp-danger)" />
      <h2>连不上服务器</h2>
      <p>{error ?? "请检查网络后重试"}</p>
      <Button variant="dark" onClick={() => void checkStatus()}>
        重试
      </Button>
    </div>
  );
}

export function NotFound() {
  return (
    <Page>
      <EmptyHint icon={MapPinOff} text="没有这个页面">
        <Link to="/">回到首页</Link>
      </EmptyHint>
    </Page>
  );
}
